/***
*
*   APP LAYOUT
*   Main application layout with navigation
*
**********/

import { Fragment, useContext, useState } from 'react';
import { AppNav, AuthContext } from 'components/lib';
import { Header } from '../../header/header';
import { usePermissions } from 'components/hooks/usePermissions';
import Style from './app.tailwind.js';

export function AppLayout(props) {

  const context = useContext(AuthContext);
  const { getNavItems, loading: rbacLoading } = usePermissions();
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  // Build nav items from RBAC permissions
  const permittedNavItems = getNavItems();
  
  // Always include sign out
  const navItems = [
    ...permittedNavItems,
    { label: 'Sign Out', icon: 'log-out', action: context.signout }
  ];

  // Fallback if RBAC not loaded yet
  const fallbackItems = [
    { label: 'Dashboard', icon: 'activity', link: '/dashboard' },
    { label: 'Sign Out', icon: 'log-out', action: context.signout }
  ];

  const handleSidebarExpandedChange = (isExpanded) => {
    setSidebarExpanded(isExpanded);
  };

  return (
    <Fragment>
      <AppNav
        type='popup'
        items={rbacLoading || permittedNavItems.length === 0 ? fallbackItems : navItems}
        onExpandedChange={handleSidebarExpandedChange}
      />

      <main className={`${Style.app} ${sidebarExpanded ? Style.appExpanded : ''}`}>
        <Header title={props.title} />
        {<props.children {...props.data} />}
      </main>
    </Fragment>
  );
}